// Lake Erie Auto Detail: site interactions (kept deliberately small).
// Nav scrollspy, smooth FAQ, vehicle-size price switch, before/after sliders + swipe dots.
(function () {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // ---- Scrollspy: mark the nav link for the section in view
  const links = [...document.querySelectorAll('.led-nav a[href*="#"]')];
  const byId = new Map();
  links.forEach((a) => {
    const el = document.getElementById(a.getAttribute('href').split('#')[1]);
    if (el) byId.set(el, a);
  });
  if (byId.size && 'IntersectionObserver' in window) {
    const spy = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (!e.isIntersecting) return;
        links.forEach((l) => l.classList.remove('is-active'));
        byId.get(e.target).classList.add('is-active');
      });
    }, { rootMargin: '-45% 0px -50% 0px' });
    byId.forEach((_, el) => spy.observe(el));
  }

  // ---- Smooth FAQ open/close
  document.querySelectorAll('.led-faq details').forEach((d) => {
    const summary = d.querySelector('summary'), body = d.querySelector('summary + *');
    if (!summary || !body || reduce) return;
    summary.addEventListener('click', (e) => {
      e.preventDefault();
      if (d.open) {
        const a = body.animate([{ height: body.offsetHeight + 'px', opacity: 1 }, { height: '0px', opacity: 0 }], { duration: 200, easing: 'ease-in' });
        a.onfinish = () => { d.open = false; };
      } else {
        d.open = true;
        body.animate([{ height: '0px', opacity: 0 }, { height: body.offsetHeight + 'px', opacity: 1 }], { duration: 240, easing: 'ease-out' });
      }
    });
  });

  // ---- Vehicle-size price switch (packages)
  document.querySelectorAll('[data-size-switch]').forEach((sw) => {
    const section = sw.closest('section') || document;
    const buttons = [...sw.querySelectorAll('[data-size]')];
    const thumb = sw.querySelector('.led-sizes__thumb');
    const moveThumb = (btn) => {
      if (!thumb || !btn) return;
      thumb.style.width = btn.offsetWidth + 'px';
      thumb.style.transform = `translateX(${btn.offsetLeft}px)`;
    };
    function choose(i) {
      buttons.forEach((b, j) => b.setAttribute('aria-pressed', j === i));
      moveThumb(buttons[i]);
      section.querySelectorAll('[data-prices]').forEach((box) => {
        let prices, urls;
        try { prices = JSON.parse(box.dataset.prices); urls = JSON.parse(box.dataset.urls); } catch (e) { return; }
        const k = Math.min(i, prices.length - 1);
        const priceEl = box.querySelector('[data-price]');
        if (priceEl && priceEl.textContent !== prices[k]) {
          priceEl.textContent = prices[k];
          if (!reduce) { priceEl.classList.remove('is-flip'); void priceEl.offsetWidth; priceEl.classList.add('is-flip'); }
        }
        const book = box.closest('article')?.querySelector('[data-book]');
        if (book && urls[k]) book.href = urls[k];
      });
    }
    buttons.forEach((b, i) => b.addEventListener('click', () => choose(i)));
    requestAnimationFrame(() => moveThumb(buttons[0]));
    addEventListener('resize', () => moveThumb(buttons.find((b) => b.getAttribute('aria-pressed') === 'true') || buttons[0]));
  });

  // ---- Before/after sliders: drag the handle (or use arrow keys on the hidden range).
  // Dragging is limited to the handle so the photos themselves can be swiped on phones.
  document.querySelectorAll('[data-ba]').forEach((frame) => {
    const handle = frame.querySelector('.led-ba__handle');
    const range = frame.querySelector('.led-ba__range');
    const set = (pct) => {
      const v = Math.max(0, Math.min(100, pct));
      frame.style.setProperty('--pos', v + '%');
      if (range) range.value = v;
    };
    const fromEvent = (e) => {
      const r = frame.getBoundingClientRect();
      set(((e.clientX - r.left) / r.width) * 100);
    };
    let dragging = false;
    handle.addEventListener('pointerdown', (e) => { dragging = true; handle.setPointerCapture(e.pointerId); e.preventDefault(); });
    handle.addEventListener('pointermove', (e) => { if (dragging) fromEvent(e); });
    handle.addEventListener('pointerup', () => { dragging = false; });
    handle.addEventListener('pointercancel', () => { dragging = false; });
    // Desktop: clicking anywhere on the photo jumps the divider there
    frame.addEventListener('click', (e) => { if (e.target !== handle && window.matchMedia('(hover: hover)').matches) fromEvent(e); });
    if (range) {
      range.style.pointerEvents = 'none';
      range.addEventListener('input', () => set(+range.value));   // keyboard: Tab to it, then arrow keys
    }
  });

  // ---- Swipe dots for the before/after carousel (phones)
  document.querySelectorAll('[data-results]').forEach((track) => {
    const dotsBox = track.parentElement.querySelector('[data-results-dots]');
    const slides = [...track.children];
    if (!dotsBox || slides.length < 2) return;
    const dots = slides.map((s, i) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('aria-label', `Show result ${i + 1}`);
      b.addEventListener('click', () => s.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', inline: 'center', block: 'nearest' }));
      dotsBox.appendChild(b);
      return b;
    });
    dotsBox.removeAttribute('aria-hidden');
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.intersectionRatio > 0.6) dots.forEach((d, i) => d.setAttribute('aria-current', slides[i] === e.target));
      });
    }, { root: track, threshold: [0.6] });
    slides.forEach((s) => io.observe(s));
  });
})();
